import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer';   
import LazyLoad from 'react-lazyload'; 
const OurSchool = () => { 
      useEffect(() => {
        document.title = 'Our School -  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li> 
<li>  About Us  </li> 
     <li> Our School </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1> Our School </h1>
         </div>
     </div>
     <div className="row">  
       <div className="clearfix">
          <LazyLoad> <img 
           src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/schoolimg.jpg" 
           className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 schoolimg" 
           alt=""
         /></LazyLoad>
           <p> The school takes the utmost care in developing the personality of each and every one of the student. The most powerful expression of personality being quality of character and character is expressed through a principle-centred living, we take a special interest in the development of human resources. To understand the human resources-traits, values, skills, cognition, feelings, experience, imagination, body system etc. we have designed suitable curriculum and stress on developing skills in physical activities, cognitive development, personal hygiene, social habits, spoken English etc. Since discipline usually functions through habits we prepare the ground for sequencing of time with regard to habits enabling individual effectiveness leading to success. We learn that in the current scenario cognitive development alone does not count, development of emotional intelligence is also equally important. Hence extra care is given to the emotional development of the child. Considerable effort will be made for the development of human relation skills, listening and team-building skills.</p>
       </div> 
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default OurSchool
